/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react'
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'
import FillButton from 'components/presenter/buttons/FillButton'
import FormTextField from 'components/presenter/form/FormTextField'
import BannerForm from 'components/presenter/form/banner/BannerForm'
import BannerFormContent from 'components/presenter/form/banner/BannerFormContent'
import { EmptyValidator, UrlValidator, EmailValidator } from 'libs/form/validator'
import { useForm } from 'libs/form/formHook'
import cn from 'classnames'
import { useStore, companyStoreId } from 'stores'
import UploadAvatar from 'components/presenter/form/UploadAvatar'
import Page from 'components/presenter/page/Page'
import * as styles from './create.module.css'

const companyName = 'companyName'
const companyUrl = 'companyUrl'
const emailId = 'email'
const telephoneId = 'telephone'

const CreateCompanyPage = () => {
  const { t } = useTranslation()
  const { navigate } = useI18next()
  const [isSkip, setSkip] = React.useState(false)

  const [cropObj, setCropObj] = useState({
    imageUrl: '',
    cropBlob: null
  })
  const companyStore = useStore(companyStoreId)

  const { onChangeValidation, getFormFieldState, isFormReady, requestAsyc, isLoading, formErrorCode } = useForm({
    [companyName]: {
      validators: [EmptyValidator],
    },
    [companyUrl]: {
      isOptional: true,
      validators: [UrlValidator],
    },
    [emailId]: {
      isOptional: true,
      validators: [EmailValidator],
    },
    [telephoneId]: {
      isOptional: true,
    },
  })

  /**
   *
   */
  async function triggerCreateCompany() {
    setSkip(true)
    const response = await requestAsyc(companyStore.actions.createCompanyProfile({
      name: getFormFieldState(companyName).value,
      url: getFormFieldState(companyUrl).value,
      telephone: getFormFieldState(telephoneId).value,
      email: getFormFieldState(emailId).value,
      file: cropObj.cropBlob
    }))

    if (!response.error) {
      navigate(`/company-profile/create/success/`)
    }
  }

  const onCrop = (blob, url) => {
    setCropObj({
      cropBlob: blob,
      imageUrl: url
    })
  }

  const handleKeyDown = async (e) => {
    if (e.key === 'Enter' && isFormReady) {
      e.preventDefault()
      await triggerCreateCompany()
    }
  }

  // Redirect to home if company profile created
  useEffect(() => {
    if(!isSkip && companyStore.getters.getCompanyProfile()) {
      navigate(`/`)
    }
  }, [companyStore.getters.getCompanyProfile()])

  return (
    <div role="main" onKeyDown={handleKeyDown}>
      <Page>
        <BannerForm isLoading={isLoading}>
          <BannerFormContent
            title={t('createCompany.title')}
            subTitle={t('createCompany.description')}
          >
            <UploadAvatar
              className={styles.upload}
              name="company logo"
              url={cropObj.imageUrl}
              uploadBtnText={t('company.uploadLogo')}
              onCrop={onCrop}
              cropOption={{
                croppedImageWidth: 600,
                croppedImageHeight: 600,
              }}
            />
            <FormTextField
              id={companyName}
              fieldData={getFormFieldState(companyName)}
              className={cn(styles.input)}
              label={t('createCompany.companyNameField')}
              type="text"
              onChange={onChangeValidation}
            />
            <FormTextField
              id={emailId}
              fieldData={getFormFieldState(emailId)}
              className={cn(styles.input)}
              label={t('company.contactEmail')}
              type="text"
              onChange={onChangeValidation}
            />
            <FormTextField
              id={telephoneId}
              fieldData={getFormFieldState(telephoneId)}
              className={cn(styles.input)}
              label={t('company.contactPhone')}
              type="text"
              onChange={onChangeValidation}
            />
            <FormTextField
              id={companyUrl}
              fieldData={getFormFieldState(companyUrl)}
              className={cn(styles.input)}
              label={t('createCompany.companyUrl')}
              placeholder={t('formFields.hint.urlformat')}
              type="text"
              onChange={onChangeValidation}
            />
            <p className={cn(styles.errorMsg)}>{formErrorCode ? `*${t(`errorCodes.${formErrorCode}`)}` : ''}</p>
            <FillButton
              className={cn(styles.btnCreate)}
              disabled={!isFormReady()}
              onClick={triggerCreateCompany}
            >
              {t('common.create')}
            </FillButton>
          </BannerFormContent>
        </BannerForm>
      </Page>
    </div>
  )
}

export default CreateCompanyPage